import React from "react";
import { Form, Input, Select, Row, Col, Card, InputNumber, Button } from "antd";

const { Option } = Select;

const Transaksi = ({ data, setData }) => {
    return (
        <Form layout="vertical">
            <Row gutter={24}>
                <Col span={12}>
                    <Card title="Harga" bordered={true}>
                        <Form.Item label="Jenis Valuta">
                            <Select placeholder="Pilih Valuta">
                                <Option value="USD">USD - US DOLLAR</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item label="NDPBM">
                            <Input.Group compact>
                                <Input style={{ width: 'calc(100% - 100px)' }} placeholder="NDPBM" />
                                <Button type="primary">Sesuai valuta terbaru</Button>
                            </Input.Group>
                        </Form.Item>
                        <Form.Item label="Harga Barang">
                            <InputNumber
                                style={{ width: "100%" }}
                                formatter={value => `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\Rp\s?|(,*)/g, '')}
                            />
                        </Form.Item>
                        <Form.Item label="Nilai Pabean dalam Rupiah">
                            <InputNumber
                                style={{ width: "100%" }}
                                disabled
                                formatter={value => `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\Rp\s?|(,*)/g, '')}
                            />
                        </Form.Item>
                        <Form.Item label="Jenis Transaksi">
                            <Select placeholder="Pilih Jenis Transaksi">
                                <Option value="IMPOR">IMPOR SEMENTARA</Option>
                            </Select>
                        </Form.Item>
                    </Card>
                </Col>
                <Col span={12}>
                    <Card title="Berat" bordered={true}>
                        <Form.Item label="Berat Kotor (KG)">
                            <InputNumber style={{ width: "100%" }} placeholder="0.0000" />
                        </Form.Item>
                        <Form.Item label="Berat Bersih (KG)">
                            <InputNumber style={{ width: "100%" }} placeholder="0.0000" />
                        </Form.Item>
                    </Card>
                </Col>
            </Row>
        </Form>
    );
};

export default Transaksi;
